// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__5UGrY","list":"PatternAutocomplete_list___xyV7"};